export class Config 
{
	constructor() {
		this.rememberPeople = $('.settings-people__button').attr('data-remember-people');

		if (cookie.get('config_people') && this.rememberPeople)
		{
			this.people = JSON.parse(cookie.get('config_people'));
		}
		else
		{
			this.people = {adult: 0, child: 0, ch_ages: []}
		}

		if (cookie.get('config_dates'))
		{
			this.dates = JSON.parse(cookie.get('config_dates'));
		}
		else
		{
			this.dates = {begin: null, end: null}
		}

		if (cookie.get('config_date'))
		{
			this.date = JSON.parse(cookie.get('config_date'));
		}
		else
		{
			this.date = null
		}

		if (window.location.pathname.match(/\/excursions\//))
		{
			this.type = 'tour';
		}
		else if (window.location.pathname.match(/\/visa-apply\//) || window.location.pathname.match(/\/visa\/form\//))
		{
			this.type = 'visa';
		}
		else if (window.location.pathname == '/visa/')
		{
			this.type = 'visa_add';
			$('.settings-calendar__month-list button').on('click', this.clickDay);
		}
		else if (window.location.pathname.match(/\/visa\//))
		{
			this.type = 'visa';
		}
		
		else if (window.location.pathname.match(/(\/services\/|\/transfer\/)/))
		{
			this.type = 'services';
		}
		else
		{
			this.type = 'hotel';
		}

		if ($('input#tour_id_input').length)
		{
			this.id = $('input#tour_id_input').val();
		}
	}

	countend (count, one, two, many = null)
	{
		let end;

		if (many == null)
			many = two;

		if (count % 10 == 1 && count % 100 != 11)
			end = one;
		else if ((count % 10 > 1 && count % 10 < 5) && (count % 100 < 11 || count % 100 > 15))
			end = two;
		else
			end = many;

		return end;
	}

	saveTravelers ()
	{
		let text;

		if (this.people.adult == 0 && this.people.child == 0)
		{
			if (this.rememberPeople)
			{
				cookie.delete('config_people');
			}
			$('.settings-people__button').removeClass('valid');

			text = this.type == 'hotel' ? 'Укажите параметры проживания' : 'Выберите гостей';
		}
		else
		{
			if (this.rememberPeople)
			{
				cookie.set('config_people', JSON.stringify(this.people));
			}
			$('.settings-people__button').addClass('valid');

			text = this.people.adult + ' взросл' + this.countend(this.people.adult, 'ый', 'ых') + ' / ' + this.people.child + this.countend(this.people.child, ' ребенок', ' ребенка', ' детей') + (this.type == 'hotel' ? ' / 1 номер' : '')
		}
		
		$('.people-room__adults-counter-value').text(this.people.adult);
		$('.settings-people__button span').text(text);

		$('.service_row input[type=hidden][name*=num_count]').val(this.people.adult + this.people.child);
		
		if (this.type == 'hotel')
		{
			hotel.loadItems();
		}
		else if (this.type == 'tour')
		{
			if (this.id)
			{
				tour.loadPrice(this.id);
			}
			else
			{
				tour.loadItems();
			}
		}
		else if (this.type == 'services')
		{
			if ($('.excursion-cars__list li[data-places]').length)
			{
				let count = this.people.adult + this.people.child;

				$('.excursion-cars__list li[data-places]').each(function(){
					if ($(this).attr('data-places') < count)
					{
						$(this).fadeOut();
					}
					else
					{
						$(this).fadeIn();
					}
				});
			}
			else
			{
				service.cipChanged();
			}
		}

	}

	loadCalendar()
	{
		let fromDate = $('.settings-calendar__day-cell button').last().val();
		$.ajax({
			url: "/ajax.php?mid=3",
			type: 'POST',
			data: {
				action: 'loadCalendar',
				fromDate: fromDate
			},
			dataType: "html",
			success: function(html){
				let newMonths = $(html);
				newMonths.find('button').on('click', config.clickDay);
				$('ul.settings-calendar__month-list').append(newMonths);
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	saveDates ()
	{
		if (!this.dates.begin || !this.dates.end)
		{
			cookie.delete('config_dates');
		}
		else
		{
			cookie.set('config_dates', JSON.stringify(this.dates));
		}
		
		let b = new Date(this.dates.begin);
		let e = new Date(this.dates.end);
		b = b.toLocaleString("ru", {
				month: "long",
				day: "numeric"});
		e = e.toLocaleString("ru", {
				year: "numeric",
				month: "long",
				day: "numeric"});
		e = e.substring(0, e.length - 3);
		$('.settings-date__button span').text(b + ' - ' + e);
		
		if (!window.location.pathname.match(/(\/crm\/)/))
			hotel.loadItems();
	}

	saveDate ()
	{
		if (!this.date)
		{
			cookie.delete('config_date');
		}
		else
		{
			cookie.set('config_date', JSON.stringify(this.date));
		}
		
		let d = new Date(this.date);
		d = d.toLocaleString("ru", {
				year: "numeric",
				month: "long",
				day: "numeric"});
		d = d.substring(0, d.length - 3);
		$('.settings-date__button span').text(d);

		if (this.id)
		{
			tour.loadPrice(this.id);
		}
		else
		{
			tour.loadItems();
		}
	}

	adultPlus (parent)
	{
		this.people.adult++;
		$(parent).closest('.settings-people-control__adults-counter').find('.settings-people-control__adults-counter-value').text(this.people.adult);
		this.saveTravelers();
	}

	adultMinus (parent)
	{
		if (this.people.adult > 0)
			this.people.adult--;
		
		$(parent).closest('.settings-people-control__adults-counter').find('.settings-people-control__adults-counter-value').text(this.people.adult);
		this.saveTravelers();
	}

	addChild (parent)
	{
		this.people.child++;
		this.people.ch_ages.push($(parent).val());
		this.saveTravelers();
		this.reloadPeoplePopup();
	}

	removeChild (parent)
	{
		let index = this.people.ch_ages.indexOf($(parent).val());
		if (index !== -1) {
			this.people.ch_ages.splice(index, 1);
		}
		this.people.child = this.people.ch_ages.length;
		this.saveTravelers();
		this.reloadPeoplePopup();
	}

	exbChange (parent)
	{
		if ($(parent).prop('checked'))
		{
			let pos = $(parent).attr('data-position');
			this.people.exb = pos;
		}
		else
		{
			this.people.exb = null;
		}

		this.saveTravelers();
		this.reloadPeoplePopup();
	}

	reloadPeoplePopup ()
	{
		let mid;
		if (this.type == 'hotel')
			mid = 3;
		else
			mid = 20;

		$.ajax({
			url: "/ajax.php?mid=" + mid,
			type: 'POST',
			data: {action: 'reloadPeoplePopup', people: this.people},
			dataType: "html",
			success: function(html){
				$('.settings-people__popup').html(html);
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	openCalendar ()
	{
		if (this.type == 'hotel')
		{
			this.markDays();
		}
		else
		{
			this.markDay();
		}

		$('.settings-calendar__month-list button').on('click', this.clickDay);
		console.log('open');
	}

	clickDay (e)
	{
		console.log(config.type);
		let el = $(this).closest('.settings-date')

		if (config.type == 'visa' || config.type == 'services')
		{
			console.log(el);
			config.date = $(this).val();
			config.markDay();

			let d = new Date(config.date);
			d = d.toLocaleString("ru", {
					year: "numeric",
					month: "2-digit",
					day: "2-digit"});
			el.find('.settings-date__button').addClass('valid');
			el.find('.settings-date__button span').text(d);
			$(this).closest('.form__item-main').find('.settings-date-input-icon').addClass('active');
			$(this).closest('.form__item-main').find('.settings-date__button span').text(d);
			$(this).closest('.form__item-main').find('input').val(d);

			el.find(".settings-date__button").removeClass("active");
			$(".settings-date__calendar").removeClass("active");
			config.closeCalendar();
			service.cipChanged();

			return ;
		}

		if (config.type == 'visa_add')
		{
			console.log(this);
			config.date = $(this).val();
			config.markDay();

			let d = new Date(config.date);
			let p = Math.ceil((d - new Date()) / (1000 * 60 * 60 * 24));
			let o = new Date(d);
			o.setDate(d.getDate() - 28);

			o = o.toLocaleString("ru", {
					year: "numeric",
					month: "2-digit",
					day: "2-digit"});
			
			d = d.toLocaleString("ru", {
					year: "numeric",
					month: "2-digit",
					day: "2-digit"});

			el.find('.settings-date__button').addClass('valid');
			el.find('.settings-date__button span').text(d);

			$(this).closest('.form__item-main').find('.settings-date-input-icon').addClass('active');
			el.find(".settings-date__button").removeClass("active");
			$(".settings-date__calendar").removeClass("active");
			//config.closeCalendar();
			
			let ans = $('.visa-get__deadline-answer');

			ans.find('.visa-get__deadline-date-in').text(d);
			ans.find('.visa-get__deadline-date-days').text(p);
			ans.find('.visa-get__deadline-date-open').text(o);

			if (p > 28)
			{
				ans.find('.visa-get__typical-card--Green').hide();
				ans.find('.visa-get__typical-card--Red').fadeIn();
			}
			else
			{
				ans.find('.visa-get__typical-card--Red').hide();
				ans.find('.visa-get__typical-card--Green').fadeIn();
			}
			

			return ;
		}

		if ($(this).closest('.settings-calendar__main').attr('data-one-day'))
		{
			config.date = $(this).val();
			config.saveDate();
			config.markDay();
			$(".settings-date__button").removeClass("active");
			$(".settings-date__calendar").removeClass("active");
			config.closeCalendar();

			return ;
		}

		if (!config.selectionStart)
		{
			$('.settings-calendar__month-list button').removeClass('day-start day-inside day-end');
			config.selectionStart = $(this).val();
			$(this).addClass('day-start');
		}
		else
		{
			config.dates.begin = config.selectionStart;
			config.dates.end = $(this).val();
			config.saveDates();
			config.selectionStart = null;
			config.markDays();

			$(this).closest('.settings-date').find('input').val(config.dates.begin + ' - ' + config.dates.end).trigger('change');
			el.find('.settings-date__button').addClass('choiced');
			
			$(".settings-date__button").removeClass("active");
			$(".settings-date__calendar").removeClass("active");
			config.closeCalendar();
		}
	}

	markDay ()
	{
		let _this = this;
		$('.settings-calendar__month-list button').removeClass('day-start day-inside day-end');
		$('.settings-calendar__month-list button').each(function(){
			if ($(this).val() == _this.date)
			{
				$(this).addClass('day-start');
				$(this).addClass('day-end');
			}
		});
	}

	markDays ()
	{
		let _this = this;
		$('.settings-calendar__month-list button').removeClass('day-start day-inside day-end');
		$('.settings-calendar__month-list button').each(function(){
			if ($(this).val() == _this.dates.begin)
				$(this).addClass('day-start');
			if ($(this).val() == _this.dates.end)
				$(this).addClass('day-end');
			if ($(this).val() > _this.dates.begin && $(this).val() < _this.dates.end)
				$(this).addClass('day-inside');
		});
	}

	closeCalendar ()
	{
		$('.settings-calendar__month-list button').off('click', this.clickDay);
		console.log('close');
	}

	closePeople ()
	{
		$(".settings-people__popup").removeClass("active");
	}

	copyWhitepaper(button) {
		// Ищем ближайший родительский блок с классом .whitepaper-block
		const whitepaperBlock = $(button).closest('.whitepaper-block');
		if (!whitepaperBlock.length) {
			console.error('Не найден родительский блок .whitepaper-block');
			return;
		}

		// Флаг, чтобы знать, нужно ли перед следующим заголовком вставлять пустую строку
		let isFirstTitle = true;

		/**
		 * Основная рекурсивная функция обработки элементов
		 * @param {jQuery} $el - jQuery-объект для обрабатываемого DOM-элемента
		 * @returns {string} - итоговый текст, извлечённый из $el и его потомков
		 */
		function processElement($el) {
			let result = '';

			// 1. Пропускаем интерактивные элементы (и их дочерние узлы тоже не должны попасть в текст)
			if ($el.is('button, input')) {
				return '';
			}

			// 2. Если у элемента есть класс message
			if ($el.attr('class')?.includes('message')) {
				// Добавим с новой строки значок и текст
				result += '\n👆 ';
				// Берём только «сырой» текст этого блока (включая вложения),
				// но не делаем рекурсию на детей, чтобы не дублировать
				result += extractText($el).trim() + '\n\n';
				return result;
			}

			// 3. Если у элемента есть класс answer (например, какой-то специальный блок)
			if ($el.attr('class')?.includes('answer') && !$el.attr('class')?.includes('visa-check__answer')) {
				result += '\n- ';
				result += extractText($el).trim() + '\n\n';
				// И аналогично не делаем рекурсию, чтобы не дублировать текст
				return result;
			}

			// 4. Если элемент — заголовок (h1-h5) или его класс содержит "title"
			if ($el.is('h1, h2, h3, h4, h5, strong') || $el.attr('class')?.includes('title')) {
				if (!isFirstTitle) {
					result += '\n'; // между заголовками вставляем пустую строку
				}
				result += `*${$el.text().trim()}*\n`; // выделяем звёздочками для мессенджеров
				isFirstTitle = false;
			}
			// 5. Если это специальный список ul.visa-card__faq-list
			else if ($el.is('ul.visa-card__faq-list')) {
				// Каждый li содержит .visa-card__faq-question и .visa-card__faq-answer
				$el.children('li').each(function () {
					const question = $(this).find('.visa-card__faq-question').text().trim();
					const answer   = $(this).find('.visa-card__faq-answer').text().trim();
					if (question) {
						result += `• ${question}\n`;
					}
					if (answer) {
						result += `- ${answer}\n\n`;
					}
				});
				return result; // прерываем рекурсию, чтобы не дублировать
			}
			// 6. Если это обычный список (ul или ol)
			else if ($el.is('ul, ol')) {
				$el.children('li').each(function () {
					result += `• ${$(this).text().trim()}\n`;
				});
				return result; // прерываем рекурсию после обработки
			}
			// 7. Если элемент — обычный текстовый контейнер (p, div, span)
			else if ($el.is('p, div, span')) {
				// Забираем текст *только* из текущего элемента
				let text = $el.clone()
					.children()   // находим детей
					.remove()     // удаляем детей
					.end()        // возвращаемся к $el
					.text().trim();

				$el.children('a').each(function () {
					text += ` ${$(this).attr('href')}`;
				});
				if (text) {
					result += `${text}\n\n`;
				}
			}

			// 8. Чтобы обработать все вложенные элементы (если они могут быть заголовками, списками и т. д.),
			//    рекурсивно обходим детей, *если* мы не прервали рекурсию return'ом в пунктах выше.
			$el.children().each(function () {
				result += processElement($(this));
			});

			return result;
		}

		/**
		 * Вспомогательная функция, рекурсивно извлекающая весь текст (без разметки) из элемента
		 * @param {jQuery} $el - jQuery-объект, из которого нужно достать «сырой» текст
		 * @returns {string}
		 */
		function extractText($el) {
			let text = '';
			$el.contents().each(function () {
				// TEXT_NODE
				if (this.nodeType === Node.TEXT_NODE) {
					text += this.textContent.trim() + ' ';
				}
				// ELEMENT_NODE
				else if (this.nodeType === Node.ELEMENT_NODE) {
					text += extractText($(this));
				}
			});
			return text;
		}

		// Запускаем рекурсивную обработку с корневого whitepaperBlock
		let textContent = processElement(whitepaperBlock);

		// Очищаем текст от лишних пробелов/переводов
		textContent = textContent.trim();

		// Копируем итог в буфер обмена
		navigator.clipboard.writeText(textContent).then(() => {
			// Меняем надпись на кнопке на "Скопировано!" на 5 секунд
			const originalText = $(button).find('span').text();
			$(button).addClass('copied');//.find('span').text('Скопировано!');
			setTimeout(() => {
				$(button).removeClass('copied');//.find('span').text(originalText);
			}, 3000);
		}).catch((err) => {
			console.error('Ошибка копирования: ', err);
		});
	}







}